import { useVariants } from 'modules/productDetail'
import { SizeChartDataAttributesValues } from 'modules/productDetail/types'
import React from 'react'

/**
 * The data we get may be incomplete. We need to first find out, which size chart attributes we are expecting on all products.
 * We iterate over all variants and build the union of all size chart attributes. Once we got that, we now with some certainty if an attribute is missing in the next step.
 * This is of course not foolproof, but it's the best we can do with the data we have.
 */
export default function useExpectedSizeChartAttributes() {
  const variants = useVariants()

  return React.useMemo(() => {
    const expected = new Map<string, SizeChartDataAttributesValues>()
    for (let i = 0; i < variants.data.length; i++) {
      const sizeChartDataEntry = variants.data[i].sizeChartData

      if (!sizeChartDataEntry) {
        continue
      }

      const sizeChartAttributes = sizeChartDataEntry.sizeChartAttributes

      if (sizeChartAttributes) {
        for (const key in sizeChartAttributes) {
          if (sizeChartAttributes[key]) {
            // At least one variant has this attribute. So we expect it to be present on all.
            expected.set(key, sizeChartAttributes[key])
          }
        }
      }
    }
    return expected
  }, [variants])
}
